<a [ngClass]="{
				active: parent.sortField === field,
				up: parent.sortAscending,
				disabled: parent.isSortDisabled
			}" (click)="onHeaderClick()" [attr.aria-label]="header">
	{{ header }}
	<span class="caret"></span>
</a>